<template>
    <div class="user-avatar-wrapper" :class="size">
        <div class="user-avatar" :style="'background:' + getUserColor(user.name)">
            <div class="user-avatar-img-wrapper" v-if="user.photoUrl"><img :src="user.photoUrl" /></div>
            <template v-else>{{ user.name[0] || '' }}</template>
        </div>
        <div class="plan-tag" v-if="subscription?.plan.tag">{{ subscription.plan.tag }}</div>
    </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'
import { Subscription, User } from '@/api/tripply/models'
import { getUserColor } from '@/api/tripply/tools'

export default defineComponent({
  props: {
    user: Object as PropType<User>,
    subscription: Object as PropType<Subscription>,
    size: String as PropType<'small'|'large'>
  },
  setup(props) {
    return { getUserColor }
  },
})
</script>
<style lang="scss" scoped>
.user-avatar-wrapper {
    display: inline-flex;
    position: relative;
    
    .plan-tag {
        position: absolute;
        top: -.5rem;
        left: -.5rem;
    }

    .user-avatar {
        height: 2.5rem;
        width: 2.5rem;
        border-radius: 100%;
        background: linear-gradient(36deg,#760979,#00d4ff);
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: 600;
        font-size: 1.25rem;
        position: relative;

        &-img-wrapper {
            height: 100%;
            width: 100%;
            border-radius: 100%;
            overflow: hidden;
            img {
                height: 100%;
                width: 100%;
            }
        }
            
    }

    &.small .user-avatar {
        height: 2rem;
        width: 2rem;
    }
    &.large {
        .user-avatar {
            height: 5rem;
            width: 5rem;
            font-size: 2.5rem;
        }
        .plan-tag {
            left: unset;
            top: .25rem;
            right: -.75rem;
        }
    }
}
</style>